import { epassprotFetch } from '@common/services/fetch';

export function fetchUserOperationPermission() {
  return epassprotFetch.get('/account/funcPermissions');
}
